import { FC, MouseEvent, useEffect, useRef } from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import { SuggestItems } from '@doda/common/src/interfaces/suggestDispatcher';
import style from './index.module.scss';

/**
 * SuggestListコンポーネントのプロパティ
 */
interface Props {
  /** サジェストリストのアイテム */
  suggests: SuggestItems['items'];
  /** サジェストアイテムがクリックされたときのハンドラー */
  onClickSuggest: (event: MouseEvent<HTMLButtonElement>) => void;
  /** サジェストリストをリセットする関数 */
  resetSuggests: () => void;
}

/**
 * 検索サイトバー・サジェストリスト
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element | null} SuggestListのJSX要素、サジェストがない場合はnull
 */
export const SuggestList: FC<Props> = ({
  suggests,
  onClickSuggest,
  resetSuggests,
}) => {
  const suggestRef = useRef<HTMLInputElement>(null);

  // サジェストメニュー以外をクリックした時にメニューを閉じる処理
  useEffect(() => {
    const handleClickOutsideSuggest = (event: Event) => {
      if (
        suggestRef.current &&
        !suggestRef.current.contains(event.target as HTMLElement)
      ) {
        resetSuggests();
      }
    };
    document.addEventListener('mousedown', handleClickOutsideSuggest);

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideSuggest);
    };
  }, [resetSuggests]);

  return (
    <>
      {suggests.length > 0 && (
        <div
          className={classNames(suggests.length && style.keywordSuggest__menu)}
          ref={suggestRef}
        >
          {suggests.map((suggest) => {
            return (
              <button
                key={suggest.t}
                type="button"
                className={style.keywordSuggest__button}
                value={suggest.t}
                onClick={onClickSuggest}
              >
                {parse(suggest.l)}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};
